import React, { useMemo } from 'react';
import { Link } from '@mui/material';
import { fundOwnershipUrl } from 'common/config/urls';
import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';
import { GridDateValueViewer } from 'components/FeaturedSpreadsheet/components';

interface DateValueViewerProps {
  cell?: {
    is_virtual?: boolean;
    value?: string;
    [key: string]: any;
  };
  [key: string]: any;
}

const DateValueViewer: React.FC<DateValueViewerProps> = props => {
  const [{ companyInfo, firmInfo }] = useStore() as unknown as UseStoreValues;

  const isVirtual = props.cell?.is_virtual;

  const fundOwnershipLink = useMemo(() => {
    if (!isVirtual || !firmInfo?.slug || !companyInfo?.slug) {
      return null;
    }
    return fundOwnershipUrl(firmInfo.slug, companyInfo.slug);
  }, [isVirtual, firmInfo?.slug, companyInfo?.slug]);

  if (isVirtual && fundOwnershipLink) {
    return (
      <Link
        href={fundOwnershipLink}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          textDecoration: 'none',
          color: 'inherit',
          '&:hover': {
            textDecoration: 'underline',
          },
        }}
      >
        <GridDateValueViewer {...props} slashFormatted />
      </Link>
    );
  }

  return <GridDateValueViewer {...props} slashFormatted />;
};

export default DateValueViewer;
